import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get customer addresses
export const getCoustomerAdderss = createAsyncThunk(
  "client/get-address",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    const customerId = localStorage.getItem("customerId");
    
    console.log("Fetching addresses for customer:", customerId);

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/customer-address/api/v1/get-address/${customerId}`,
        {},
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      
      console.log("Address fetch response:", response);
      
      // Ensure we return a consistent response structure
      return response;
    } catch (error) {
      console.error("Error fetching addresses:", error);

      return rejectWithValue(
        error.response?.data?.message || "Error fetching addresses"
      );
    }
  }
);
